import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'

import SortMenu from '@components/UI/SortMenu'
import { IApplicationState } from '@store'
import { fetchInfluencerIdentities } from '@store/brandFans'
import { selectInfluencerIdentitySortOptions } from '@store/me'
import BrandFansInfluencerIdentityTopPanelTrackedRoute from './TrackedRoute'

const InfluencerIdentityTopPanelSort: React.FC = () => {
  const dispatch = useDispatch()
  const sortOptions = useSelector((state: IApplicationState) =>
    selectInfluencerIdentitySortOptions(state),
  )

  const onSortByChange = (sortBy?: string) => {
    // Only trigger the fetch if we have a valid sort value
    if (sortBy) {
      const resetList = true
      dispatch(fetchInfluencerIdentities(false, resetList, sortBy))
    }
  }

  return (
    <SortMenu
      anchor={'right'}
      trackingWrapper={{
        component: BrandFansInfluencerIdentityTopPanelTrackedRoute,
        createProps: (value: string) => ({
          source: 'sort_filter',
          sortBy: value,
        }),
      }}
      options={sortOptions.map((option) => ({
        value: option,
        display: <FormattedMessage id={`brandFans.list.sort.option.${option}`} />,
      }))}
      onSortByChange={onSortByChange}
    />
  )
}

export { InfluencerIdentityTopPanelSort }
export default InfluencerIdentityTopPanelSort
